import { render, staticRenderFns } from "./SharedMediaForm.vue?vue&type=template&id=30ce3d22&"
import script from "./SharedMediaForm.vue?vue&type=script&lang=js&"
export * from "./SharedMediaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports